import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import PropTypes from 'prop-types';

import { commonStyles } from '../../styles/styles';

const ManagerCheckbox = ({ classes, checkedStatus, input }) => (
  <FormControlLabel className="pb-3"
    control={
      <Checkbox
        checked={checkedStatus}
        {...input}
        value={`"false"`}
        classes={{
          root: classes.root,
          checked: classes.checked,
        }}
      />
    }
    label="I hereby confirm that I have reviewed and approved the information contained in the Workplace Skills Report"
  />
);

const styles = () => ({
  ...commonStyles,
  checked: {
    color: '#CC0000',
  },
  label: {
    color: '#4A4A4A',
    lineHeight: '18px',
  },
  root: {
    color: '#A0A0A0',
    '&$checked': {
      color: '#CC0000',
    },
  },
});

export default compose(withStyles(styles))(ManagerCheckbox);
